export const BUD_API_TEST = "https://bud.apps.test.det.nsw.edu.au/api/v1";
export const BUD_API_PROD = "https://bud.apps.det.nsw.edu.au/api/v1";

export const HIGHCHARTS_DEFAULTS = {
  credits: {
    enabled: false,
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems: ["printChart", "separator", "downloadCSV"],
      },
    },
  },
};

export const FILTER_DESCRIPTIONS = {
  'warranty': {
    'expired': 'Expired Warranty',
    'expiring_soon': 'Approaching Warranty',
    'covered': 'Under Warranty',
    'data_missing': 'Data not available',
  },
  'utilisation': {
    'this_week': '7 days',
    'last_week': '7 to 15 days',
    'several_weeks_ago': '15 to 30 days',
    'over_30_days_old': '30+ days',
    'data_missing': 'Data not available',
  },
  'age': {
    '1_year_old': '0-1 year old',
    '2_years_old': '1-2 years old',
    '3_years_old': '2-3 years old',
    '4_years_old': '3-4 years old',
    '5_plus_years_old': '4+ years old',
    'data_missing': 'Data not available',
  }
};

export const HEARTBEAT_EXEMPTIONS = [
  'Logout',
  'Login',
  'SetToken',
  'SessionExpired',
  'AuthenticationFailure'
];
